import { render, staticRenderFns } from "./Family-statements-pagination.vue?vue&type=template&id=5a9ef6b0"
import script from "./Family-statements-pagination.vue?vue&type=script&lang=js"
export * from "./Family-statements-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports